<template>
  <div>
    <div class="mytitle">
      <h2>密码修改</h2>
    </div>
    <div
        v-loading="fullscreenLoading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <div class="unit">
        <div>
          <label>老密码：</label>
          <input type="password" v-model="oldpwd" class="sys_input" />
        </div>
        <div>
          <label>新密码：</label>
          <input type="password" v-model="newpwd" class="sys_input" />
        </div>
      </div>
      <div class="unit">
        <button @click="updData" class="sys_btn">保存</button>
      </div>
    </div>
  </div>
</template>

<script>
 import t from '@/utils/type.js'
import { Method_EasyUpdate } from '@/utils/loadhttpdata.js';
// const url = require("@/assets/verify/images/1.jpg");
export default {
  data() {
    return {
      fullscreenLoading:false,
      msg_obj:{},
      oldpwd:'',
      newpwd:'',
      // sys_yd_show:true,
      // menu:[{"id":1,"name":"首页"},{"id":2,"name":"产品展示"},{"id":3,"name":"加入我们"},{"id":4,"name":"代理加盟"},{"id":5,"name":"关于我们"}],
    };
  },
  methods: {
    updData:function(){
      this.fullscreenLoading=true;
      this.$post(
        t.http_method,
        Method_EasyUpdate( 'data_userpwd','',this.oldpwd,this.newpwd)
      ).then(res => {
        console.log(res);
        res=JSON.parse(res);
        this.$message({message:res.data.msg,type:'success'})
        this.fullscreenLoading=false;
      });

    }
  }
};

</script>
<style scoped>
.mytitle > h2 {
  color: #333333;
}
.mynote > h3 {
  color: #ee1414;
  font-weight: 100;
}

.mytitle {
  font-size: 16px;
  color: #1c19e2;
}
.mynote {
  width: 100%;
  font-size: 12px;
  text-align: left;
  margin-bottom: 10px;
}

.sys_note {
  font-size: 12px;
  font-weight: 100;
  border-bottom: 1px solid #cccccc;
  padding-bottom: 20px;
}
.sys_input {
  width: 280px;
  height: 24px;
  outline: none;
  padding-left: 10px;
}
.sys_btn {
  margin: 10px 10px 0 20px;
  background: #4f5f6f;
  width: 56px;
  height: 28px;
  border: none;
  outline: none;
  cursor: pointer;
  color: #fff;
}

.unit {
  margin-top: 2px;
}
.unit > label {
  width: 80px;
  display: inline-block;
}
.unit > button {
  display: block;
  margin-left: 260px;
  box-shadow: #cccccc;
}
.unit > div {
  margin-top: 20px;
}
</style>
